import { Type } from "class-transformer";
import { ConcernedPersonModel } from "./concernedPerson.model";

export class TravelLegModel {
    tlDossierHelpPlanId: string;
    tlId: string ;
    @Type(() => Date) tlArrivalDate: Date;
    @Type(() => Date) tlDepartureDate: Date;
    tlFromCountry: any;
    tlToCountry: any;
    tlFromStation: string;
    tlToStation: string;
    tlFromAirport: any;
    tlToAirport: any;
    tlAirline: any;
    tlFlightNumber: number;
    tlTrainNumber: number;
    tlComment: string;
    tlNewAirline: string;
    tlFromLocation:string;
    tlToLocation:string;
    tlTransportMode : string ;
    tlIsRepatriationMedicalUrgent: boolean ;
    tlMedicalSupportNeeded: boolean ;
    tlMedicalApproval : string ;
    tlLegrest : string ;
    tlStretcher: boolean ;
    tlMeetAndAssist: boolean ; 
    tlWheelchair: string ;
    tlOxygen: string ;
    tlAmountOfOxygen: string ;
    tlLuggage: string ;
    tlFromCity: string;
    tlToCity: string;
    tlFromIataCode: string;
    tlToIataCode: string;
    tlPta: boolean;
    tlTarmac: boolean;
    tlPnr: string;
    tlClass: number;
    concernedPersonHelpPlans : ConcernedPersonModel[]=[];
  }